import React, { Fragment } from "react";
import { connect } from "react-redux";
import ReScheduleDelivery from "../components/ReScheduleDelivery";
import { requestDelivery } from "../actions/deliveryAction";
import Spinner from "../components/layout/Spinner";

class ReScheduleDeliveryContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.requestDelivery(this.props.match.params.id);
  }
  render() {
    const { loading, delivery } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <ReScheduleDelivery delivery={delivery} history={history} />
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  delivery: state.requestDelivery.delivery,
  loading: state.requestDelivery.loading,
});
const mapDispatchToProps = (dispatch) => ({
  requestDelivery: (deliveryId) => dispatch(requestDelivery(deliveryId)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReScheduleDeliveryContainer);
